import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-travel-advice',
  templateUrl: './travel-advice.component.html',
  styleUrls: ['./travel-advice.component.scss'],
  standalone: false
})
export class TravelAdviceComponent {
  @Input() travelAdvice: { link: string; country: string } | null = null;
}
